import { DEFAULT_BRAND_NAME, brandText as sharedBrandText } from 'careit';

const RESERVED_SUBDOMAINS = new Set([
  'app',
  'dashboard',
  'www',
  'api',
  'staging',
  'staging-api',
  'staging-app',
  'my',
  'kb',
  'staging-kb',
  'assets',
  'dev-assets',
  'localhost',
]);
const BRAND_APEX_DOMAINS = ['careit.com', 'careitapp.com'];

export { DEFAULT_BRAND_NAME };

let runtimeBrandName = DEFAULT_BRAND_NAME;
let runtimeBrandSlug = null;

export const setRuntimeBrandName = (brandName) => {
  const normalized =
    typeof brandName === 'string' && brandName.trim()
      ? brandName.trim()
      : DEFAULT_BRAND_NAME;
  runtimeBrandName = normalized;
};

export const getRuntimeBrandName = () => runtimeBrandName;

export const setRuntimeBrandSlug = (slug) => {
  runtimeBrandSlug =
    typeof slug === 'string' && slug.trim() ? slug.trim().toLowerCase() : null;
};

export const getRuntimeBrandSlug = () => runtimeBrandSlug;

export const brandText = (value, brandName = runtimeBrandName) =>
  sharedBrandText(value, brandName);

const readBrandOverride = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has('brand')) {
      const value = (params.get('brand') || '').trim().toLowerCase();
      if (value) {
        localStorage.setItem('brand-override', value);
      } else {
        localStorage.removeItem('brand-override');
      }
    }
    return localStorage.getItem('brand-override') || null;
  } catch {
    return null;
  }
};

export const getBrandSlugFromHost = () => {
  const override = readBrandOverride();
  if (override) return override;

  const hostname = (window.location.hostname || '').toLowerCase();
  const isCareitDomain = BRAND_APEX_DOMAINS.some(
    (apex) => hostname === apex || hostname.endsWith(`.${apex}`)
  );
  if (!isCareitDomain) return null;
  const labels = hostname.split('.');
  if (labels.length < 3) return null;

  const label = labels[0];
  if (!label || RESERVED_SUBDOMAINS.has(label)) return null;
  return label;
};

export const BRAND_SLUG = getBrandSlugFromHost();
setRuntimeBrandSlug(BRAND_SLUG);
